export default "<video #videopreview webkit-playsinline playsinline [src]=\"src\" (click)=\"openVideo()\"></video>";